// extracted by mini-css-extract-plugin
module.exports = {"label":"label_label__uy1Ex","label_container":"label_label_container__YP3X0","label_wrapper":"label_label_wrapper__n_Mcv","second":"label_second__DCKiG","hide":"label_hide__3pAYE"};